import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger';

export default {
  init() {
    console.log('single Progetto');
    
    gsap.registerPlugin(ScrollTrigger);

    const h1 = document.querySelector(".aboveProgetto h1");
    const location = document.querySelector(".aboveLocation");
    const metratura = document.querySelector(".aboveMetratura");
    const text = document.querySelectorAll(".aboveProgetto__descrizione p");


    let mm = gsap.matchMedia()

    mm.add("(min-width: 769px)", () => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: '.aboveProgetto',
          start: '20% 80%',
          end: '30% 60%',
          scrub: true,
          markers: false,
        }
      });

      tl.fromTo(h1,
        { x: -150, opacity: 0 },
        { x: 0, opacity: 1, duration: 1 }
      )
      .fromTo(location,
        { x: -150, opacity: 0 },
        { x: 0, opacity: 1, duration: 1 },
        "-=0.8"
      )
      .fromTo(metratura,
        { x: -150, opacity: 0 },
        { x: 0, opacity: 1, duration: 1 },
        "-=0.8"
      )
      .fromTo(text,
        { x: 150, opacity: 0 },
        { x: 0, opacity: 1, duration: 1, stagger: 0.2 },
        "-=0.8"
      );
    })

    mm.add("(max-width: 768px)", () => {
      gsap.fromTo(h1,
        { x: -200, opacity: 0 },
        { x: 0, opacity: 1, duration: 1 }
      )
      gsap.fromTo(location,
        { x: 250, opacity: 0 },
        { x: 0, opacity: 1, duration: 1 },
        "-=0.8"
      )
      gsap.fromTo(metratura,
        { x: 200, opacity: 0 },
        { x: 0, opacity: 1, duration: 1 },
        "-=0.8"
      )
      gsap.fromTo(text,
        { y: 150, opacity: 0 },
        { y: 0, opacity: 1, duration: 1, stagger: 0.2 },
        "-=0.8"
      );
    })

    


    /*
    gsap.fromTo(h1,
      { x: -150, opacity: 0 },
      {
        x: 0,
        opacity: 1,
        duration: 1,
        scrollTrigger: {
          trigger: '.aboveProgetto',
          markers: true,
          start: 'top 80%',
          end: '30% 60%',
          scrub: true,
        },
      }
    );
    gsap.fromTo(location,
      { x: -150, opacity: 0 },
      {
        x: 0,
        opacity: 1,
        duration: 1,
        scrollTrigger: {
          trigger: '.aboveProgetto',
          markers: true,
          start: 'top 80%',
          end: '30% 60%',
          scrub: true,
        },
      }
    );
    gsap.fromTo(metratura,
      { x: -150, opacity: 0 },
      {
        x: 0,
        opacity: 1,
        duration: 1,
        scrollTrigger: {
          trigger: '.aboveProgetto',
          markers: true,
          start: 'top 80%',
          end: '30% 60%',
          scrub: true,
        },
      }
    );
    */

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
